import { useMemo } from 'react'
import { MaintenanceDirectiveObjectiveData } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwarding.type'
import { MaintenanceEstablishmentChoiceAuctionEntryProposalData } from '../../types/auctionEntryProposal.type'
import PieceRow from './PieceRow'
import ProposalGroupHeader from './ProposalGroupHeader'

interface AuctionProposalDetailsExecutionObjectivePiecesProps {
  executionObjective: MaintenanceDirectiveObjectiveData
  proposalDetails: MaintenanceEstablishmentChoiceAuctionEntryProposalData | undefined
  pieceStartIndex: number
  auctionEntryUpdatedAt: number
  proposalDetailsUpdatedAt: number
}

const AuctionProposalDetailsExecutionObjectivePieces = ({
  executionObjective,
  proposalDetails,
  pieceStartIndex,
  auctionEntryUpdatedAt,
  proposalDetailsUpdatedAt,
}: AuctionProposalDetailsExecutionObjectivePiecesProps) => {
  const piecesCountDisplay = useMemo(() => {
    const count = executionObjective.execution_pieces?.length || 0

    if (count === 0) return 'Nenhuma peça'
    if (count === 1) return '1 Peça'
    return `${count} Peças`
  }, [auctionEntryUpdatedAt])

  const totalValueSum = useMemo(() => {
    return (
      executionObjective.execution_pieces?.reduce((prev, curr, index) => {
        const fieldIndex = pieceStartIndex + index
        const formPiece = proposalDetails?.proposal_content?.piece_modifications?.[fieldIndex]
        const originalUnitPrice = Number(curr.unit_price) || 0
        const quantity = Number(curr.quantity) || 0

        const newUnitPriceNumber = formPiece?.new_unit_price ? Number(formPiece.new_unit_price) : null

        if (newUnitPriceNumber !== null && newUnitPriceNumber !== originalUnitPrice) {
          return prev + newUnitPriceNumber * quantity
        }

        return prev + (Number(curr.total_value) || 0)
      }, 0) || 0
    )
  }, [auctionEntryUpdatedAt, proposalDetailsUpdatedAt, pieceStartIndex])

  return (
    <div className="flex flex-col gap-2">
      <ProposalGroupHeader
        title="Peças"
        countDisplay={piecesCountDisplay}
        totalValueSum={totalValueSum}
      />

      <div className="flex flex-col gap-3">
        {executionObjective.execution_pieces?.map((executionPiece, index) => {
          const fieldIndex = pieceStartIndex + index
          const rawModification = proposalDetails?.proposal_content?.piece_modifications?.[fieldIndex]
          const proposalModification = rawModification ? {
            new_unit_price: rawModification.new_unit_price ? Number(rawModification.new_unit_price) : null,
            new_warranty_in_days: rawModification.new_warranty_in_days ?? null,
          } : undefined

          return (
            <PieceRow
              key={executionPiece.id}
              executionPiece={executionPiece}
              proposalModification={proposalModification}
            />
          )
        })}
      </div>
    </div>
  )
}

export default AuctionProposalDetailsExecutionObjectivePieces
